<template>
  <div>
    <portal :disabled="!usePortalHeader" to="XVtableVirtualScrollPortalhtml">
      <div class="XVdatagridheaderDiv">
        <!-- Tonen elke columnname die staan gedefinieert in tblPEapiProcTableColumn voor deze procedure en table -->
        <div
          v-for="(columnsetting, index) in tablecolumnsvisible"
          :style="columnWidthStyles[index]"
          :key="index"
          v-on:click="sortBy(firstCharToLowerCase(columnsetting.tblPEapiProcTableColumnName))"
          :class="
            iscolumnvisible(
              columnsetting.tblPEapiProcTableColumnVisibleMD,
              columnsetting.tblPEapiProcTableColumnVisibleSM,
              columnsetting.tblPEapiProcTableColumnVisibleXS
            )
          "
        >
          <a v-if="columnsetting.tblPEapiProcTableColumnSortable === 1" class="XVtableVirtualScrollColumntextheader">
            {{ columnsetting.columnname }}
          </a>
          <span
            v-if="columnsetting.tblPEapiProcTableColumnSortable === 0"
            class="XVtableVirtualScrollColumntextheader"
            disabled
            >{{ columnsetting.columnname }}</span
          >
          <XVhelpcontrol
            v-if="
              columnsetting.tblPEapiProcTableColumnHelpTextID !== null &&
              columnsetting.tblPEapiProcTableColumnHelpTextID !== ''
            "
            :helptext="translation(columnsetting.tblPEapiProcTableColumnHelpTextID)"
          ></XVhelpcontrol>
          <i
            v-if="sortKey == firstCharToLowerCase(columnsetting.tblPEapiProcTableColumnName)"
            v-bind:class="[reverse ? false : 'fa fa-arrow-down', 'fa fa-arrow-up']"
            aria-hidden="true"
          ></i>
        </div>
        <th :class="breakpointHidden + ' ' + chevronClass"></th>
        <th colspan="500" style="width: 0"></th>
        <!-- {{ translation(14541) }} = text-id van details. ook dan toevoegen in contentwrapper. dit kan weg als definitief is dat er geen text boven staat -->
      </div>
    </portal>

    <div v-for="(item, index) in tabledataFiltered" :key="index">
      <div
        :id="'msg-' + item.tblMessageID"
        class="XVdatagriditemDiv"
        :key="item.tableRowState.storeTableindex + 'datarow'"
        :class="DefineRowClass(item)"
      >
        <!-- Tonen elke column van tabledata met de columns zoals die staan gedefinieert in tblPEapiProcTableColumn voor deze procedure en table -->
        <div
          v-for="(columnsetting, indexcol) in tablecolumnsvisible"
          :key="indexcol"
          :style="columnWidthStyles[indexcol]"
          :class="
            iscolumnvisible(
              columnsetting.tblPEapiProcTableColumnVisibleMD,
              columnsetting.tblPEapiProcTableColumnVisibleSM,
              columnsetting.tblPEapiProcTableColumnVisibleXS
            )
          "
        >
          <slot
            :name="firstCharToLowerCase(columnsetting.tblPEapiProcTableColumnName)"
            :rowcountindex="index"
            :celldata="item[firstCharToLowerCase(columnsetting.tblPEapiProcTableColumnName)]"
            :index="item.tableRowState.storeTableindex"
            :columname="firstCharToLowerCase(columnsetting.tblPEapiProcTableColumnName)"
            :row="item"
            >{{ item[firstCharToLowerCase(columnsetting.tblPEapiProcTableColumnName)] }}</slot
          >
        </div>
        <div :class="chevronClass" v-on:click="toggleDetails(item)">
          <i
            v-bind:class="[item.tableRowState.rowVisible ? true : 'fa fa-chevron-down', 'fa fa-chevron-up']"
            aria-hidden="true"
          ></i>
        </div>
      </div>
      <div
        v-if="
          (item.tableRowState.editModus === true && (wLG === true || wXL == true)) ||
          (item.tableRowState.rowVisible === true && wLG === false && wXL === false) ||
          (item.tableRowState.rowVisible === true && chevronhiddenDesktop === false)
        "
        :class="detailRow"
        :key="item.tableRowState.storeTableindex + 'rowdetail'"
      >
        <div>
          <slot :row="item" :index="item.tableRowState.storeTableindex" name="detailrow">
            <!-- rowvisible is boolean -->
            <!-- for each loop voor elke colom -->
            <ZoomYTransition>
              <div class="margin15">
                <div
                  :class="
                    iscolumnInVisible(
                      columnInVis.tblPEapiProcTableColumnVisibleMD,
                      columnInVis.tblPEapiProcTableColumnVisibleSM,
                      columnInVis.tblPEapiProcTableColumnVisibleXS
                    )
                  "
                  v-for="(columnInVis, indexInVisCol) in tablecolumnsvisible"
                  :key="indexInVisCol"
                >
                  <!-- <div class="row">
                        <div :class="rowDetailHeaders">
                          <label>{{columnInVis.columnname}}</label>
                        </div>
                        <div
                          class="col-md-8 col-sm-8 col-xs-12 form-group"
                        >{{tablerow[columnInVis.tblPEapiProcTableColumnName]}}</div>
                  </div>-->
                  <slot
                    :name="firstCharToLowerCase(columnInVis.tblPEapiProcTableColumnName) + '_detailrow'"
                    :rowcountindex="index"
                    :celldata="item[firstCharToLowerCase(columnInVis.tblPEapiProcTableColumnName)]"
                    :index="item.tableRowState.storeTableindex"
                    :columname="firstCharToLowerCase(columnInVis.tblPEapiProcTableColumnName)"
                    :row="item"
                  >
                    <!-- let op, gebruik "_detailrow" achter naam van het slot -->
                    <div class="row">
                      <div :class="rowDetailHeaders">
                        <label>{{ columnInVis.columnname }}</label>
                      </div>
                      <div class="col-md-8 col-sm-8 col-xs-12 form-group">
                        {{ item[firstCharToLowerCase(columnInVis.tblPEapiProcTableColumnName)] }}
                      </div>
                    </div>
                  </slot>
                </div>
                <slot
                  name="detailrowbottom"
                  :rowcountindex="index"
                  :index="item.tableRowState.storeTableindex"
                  :row="item"
                ></slot>
              </div>
            </ZoomYTransition>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'
import { FAMixin, util } from 'pevueglobal'
import { ZoomYTransition } from 'vue2-transitions'
import { mapActions } from 'vuex'
export default {
  name: 'XVtableVirtualScroll',
  components: { ZoomYTransition },
  mixins: [FAMixin],
  props: {
    dynamicScrolleEnabled: {
      type: Boolean,
      default: false,
    },
    tablesetting: {
      type: Object,
      required: true,
    },
    tablecolumnsetting: {
      type: Array,
      required: true,
    },
    tabledata: {
      type: Array,
      required: true,
    },
    columnwidth: {
      type: Array,
    },
    filterfunc: {},
    XVtableSetRowStateProperty: undefined,
    paging: {
      type: Boolean,
      default: false,
    },
    detailVisibleLargeScreen: {
      // als detailVisibleLargeScreen true is dan de visible detailrow ook tonen op MD en LG scherm
      type: Boolean,
      default: false,
    },
    tableSearchBox: {
      type: Boolean,
      default: false,
    },
    chevronhiddenDesktop: {
      type: Boolean,
      default: true,
    },
    usePortalHeader: {
      type: Boolean,
      default: false,
    },
    formatDateRelative: {
      type: Boolean,
      default: false,
    },
    messageId: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      ThrottleRows: 20,
      pagingindex: 0,
      countrowstabledata: 0,
      FilteredTableData: [],
      breakpointHidden: this.chevronhiddenDesktop ? 'hidden-md hidden-lg' : '',
      // detailRow: this.detailVisibleLargeScreen ? 'XVdetailRow' : 'hidden-md hidden-lg XVdetailRow',
      chevronClass: this.chevronhiddenDesktop ? 'hidden-md hidden-lg XVcolDetail' : '' + ' XVcolDetail',
      totalrows: 0,
      chevronUpDown: false,
      searchBoxText: '',
    }
  },
  watch: {
    messageId(newId) {
      this.scrollToRow(newId)
    },
    tabledata() {
      // table is loaded dynamically
      if (this.messageId) {
        this.scrollToRow(this.messageId)
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  computed: {
    // van detailrow een computed property gemaakt
    detailRow: function () {
      if (this.detailVisibleLargeScreen === true) {
        return 'hidden-md hidden-lg XVdetailRow'
      } else {
        return 'XVdetailRow'
      }
    },
    rowDetailHeaders: function () {
      if (this.wXS || this.wSM) {
        return 'col-md-4 col-sm-4 col-xs-12'
      } else {
        return 'col-md-4 col-sm-4 col-xs-12 form-group'
      }
    },
    pagetotal: function () {
      // Page total word berekend door:
      // Totaal aantal rijen -1. 1 aftrekken zodat als Totaal aantal rijen gelijk is aan pagingsize dit 1 pagina word en er dan geen navigatie naar volgende pagina's moet komen.
      // Dan absolute maken zodat -1 weer positief word.
      // Dit aantal delen door de pagingsize. Afronden naar beneden op een geheel getal dmv floor.
      // Concat dit met 1. Is nodig voor de verdere verwerking.
      return Math.floor(Math.abs(this.totalrows - 1) / this.tablesetting.tblPEapiProcTablePagingsize) + 1
    },
    columnWidthStyles: function () {
      // bepaal de breedte a.h.v. definities in tblPEapiProcTableColumnWidth
      let temparray = []
      this.tablecolumnsetting.forEach((tablecolumn) => {
        if (this.wXS) {
          if (tablecolumn.tblPEapiProcTableColumnVisible === 1 && tablecolumn.tblPEapiProcTableColumnVisibleXS === 1) {
            temparray.push({
              flex:
                tablecolumn.tblPEapiProcTableColumnWidthXS === null
                  ? '0 0 auto'
                  : tablecolumn.tblPEapiProcTableColumnWidthXS,
            })
          } else {
            if (tablecolumn.tblPEapiProcTableColumnVisible === 1) {
              temparray.push({ flex: '0 0 auto' })
            }
          }
        }
        if (this.wSM) {
          if (tablecolumn.tblPEapiProcTableColumnVisible === 1 && tablecolumn.tblPEapiProcTableColumnVisibleSM === 1) {
            temparray.push({
              flex:
                tablecolumn.tblPEapiProcTableColumnWidthSM === null
                  ? '0 0 auto'
                  : tablecolumn.tblPEapiProcTableColumnWidthSM,
            })
          } else {
            if (tablecolumn.tblPEapiProcTableColumnVisible === 1) {
              temparray.push({ flex: '0 0 auto' })
            }
          }
        }
        if (this.wMD || this.wXL || this.wLG) {
          if (tablecolumn.tblPEapiProcTableColumnVisible === 1 && tablecolumn.tblPEapiProcTableColumnVisibleMD === 1) {
            temparray.push({
              flex:
                tablecolumn.tblPEapiProcTableColumnWidthMD === null
                  ? '0 0 auto'
                  : tablecolumn.tblPEapiProcTableColumnWidthMD,
            })
          } else {
            if (tablecolumn.tblPEapiProcTableColumnVisible === 1) {
              temparray.push({ flex: '0 0 auto' })
            }
          }
        }
      })
      return temparray
    },
    paginglabel: function () {
      let curpage = this.pagingindex + 1
      return ' ' + this.translation(15308) + ' ' + curpage + ' ' + this.translation(15309) + ' ' + this.pagetotal
    },
    sortKey() {
      let sortk = ''
      this.tablecolumnsetting.forEach((tablecolumn) => {
        if (
          (tablecolumn.tblPEapiProcTableColumnSortableDefault === 1 ||
            tablecolumn.tblPEapiProcTableColumnSortableDefault === 2) &&
          tablecolumn.tblPEapiProcTableColumnSortable === 1 &&
          this.tablesetting.tblPEapiProcTableSortable === 1
        ) {
          sortk = this.firstCharToLowerCase(tablecolumn.tblPEapiProcTableColumnName)
        }
      })
      return sortk
    },
    reverse() {
      let rev = false

      this.tablecolumnsetting.forEach((tablecolumn) => {
        if (this.firstCharToLowerCase(tablecolumn.tblPEapiProcTableColumnName) === this.sortKey) {
          // Als tblPEapiProcTableColumnSortableDefault = 1 dan is het ascending(false), 2 is descending)true)
          if (tablecolumn.tblPEapiProcTableColumnSortableDefault === 1) {
            rev = false
          } else {
            rev = true
          }
        }
      })
      return rev
    },
    tabledataFiltered: function () {
      let hasSeperateSortColumn = false
      let SeperateSortColumn = ''
      // De tabledata in en interne table zetten omdat tabledata een property is en we die niet kunnen aanpassen.
      let Itabledata = [...this.tabledata] // deep clone van het object omdate we anders in een update loop komen, dit is alleen een deep clone van de array, en niet van de objecten in de array
      // Checken welke column default sortItabledataable staat in tblPEapiProcTableColumn. Deze moet dus bij starten pagina op sortable staan. En de table moet op sortable staan en de column moet sortable staan.
      // Zorda de functie sortby gebruikt word (dit is de onclick event van de header) dan verandert deze sortableDefault key. Dit gebeurt in de sortXVTable die staat gedefinieert in de state van deze pagina.

      this.tablecolumnsetting.forEach((tablecolumn) => {
        if (
          (tablecolumn.tblPEapiProcTableColumnSortableDefault === 1 ||
            tablecolumn.tblPEapiProcTableColumnSortableDefault === 2) &&
          tablecolumn.tblPEapiProcTableColumnSortable === 1 &&
          this.tablesetting.tblPEapiProcTableSortable === 1
        ) {
          // check of er voor deze kolom een sorteer kolom is
          if (tablecolumn.tblPEapiProcTableColumnSortColumn !== null) {
            hasSeperateSortColumn = true
            SeperateSortColumn = tablecolumn.tblPEapiProcTableColumnSortColumn
          }
        }
      })

      // Als de columnname = de column waarop men klikt dan daarmee sorteren. De sortkey word bepaalt met de functie sortby (dit is de onclick event van de header).
      this.tablecolumnsetting.forEach((tablecolumn) => {
        if (this.firstCharToLowerCase(tablecolumn.tblPEapiProcTableColumnName) === this.sortKey) {
          // sorteer tabel a.h.v. sortkey of SeperateSortColumn als deze gevuld is
          Itabledata = Itabledata.sort((o1, o2) => {
            let o1Value
            let o2Value
            if (hasSeperateSortColumn === false) {
              o1Value = o1[this.sortKey]
              o2Value = o2[this.sortKey]
            } else {
              o1Value = o1[SeperateSortColumn]
              o2Value = o2[SeperateSortColumn]
            }

            // string sorteer functie, appu en lowercase gelijkwaardig stellen
            if (
              tablecolumn.tblPEapiProcTableColumnType === null ||
              tablecolumn.tblPEapiProcTableColumnType === 'string'
            ) {
              o1Value = o1Value === null ? '' : o1Value.toUpperCase()
              o2Value = o2Value === null ? '' : o2Value.toUpperCase()
            }

            // decimal sorteerfunctie
            if (tablecolumn.tblPEapiProcTableColumnType === 'decimal') {
              o1Value = o1Value === null ? 0 : parseFloat(o1Value)
              o2Value = o2Value === null ? 0 : parseFloat(o2Value)
            }

            // datum en integer sorteren automatisch al goed
            // 1e waarde is kleiner dan 2e waarde, this.reverse geeft asc en desc
            if (o1Value < o2Value) {
              return this.reverse ? 1 : -1
            }
            // 1e waarde is groter dan 2e waarde
            if (o1Value > o2Value) {
              return this.reverse ? -1 : 1
            }

            // 1e waarde is gelijk aan 2e waarde, op de index sorteren om te voorkomen dat ie random gaat sorteren na state change
            return o1.tableRowState.storeTableindex > o2.tableRowState.storeTableindex ? -1 : 1
          })
        }
      })

      // .indexOf zoeken of iets in een string zit, als het er niet in zet geeft ie -1
      //

      Itabledata = Itabledata.filter((tablerow) => {
        let match = false
        // console.log(tablerow.tblExternalOrganizationAdministratorID.toString().includes(this.searchBoxText))
        // this.tablecolumnsetting.filter(d => d.tblPEapiProcTableColumnVisible === 1 )
        if (this.searchBoxText === '') {
          return true
        } else {
          this.tablecolumnsetting.forEach((tablecolumn) => {
            const key = this.firstCharToLowerCase(tablecolumn.tblPEapiProcTableColumnName)
            // in alle 4 niet voor, dan pas false
            if (
              tablecolumn.tblPEapiProcTableColumnType === 'string' &&
              tablerow[key] !== undefined &&
              tablerow[key] !== null
            ) {
              // console.log(tablerow[tablecolumn.tblPEapiProcTableColumnName].toString().includes(this.searchBoxText)) // true false false false true
              match = match + tablerow[key].toString().toLowerCase().includes(this.searchBoxText.toLowerCase())
            }
            if (tablecolumn.tblPEapiProcTableColumnType === 'date' && tablerow[key] !== null) {
              match = match + util.jsDateToStringDate(new Date(tablerow[key])).includes(this.searchBoxText)
            }
          })
        }

        return match
        // return boolean voor filter
      })

      // filter functie van de pagina, rijen worden gefiltered
      if (this.filterfunc !== undefined) {
        Itabledata = this.filterfunc(Itabledata)
      }

      // Als er opnieuw word gefilterd dan moet de pagindex weer op 0 gezet worden. Dit checken door de nieuwe aantal rijen te vergelijken met de oude aantal rijen.
      if (Itabledata.length !== this.totalrows) {
        // reset sortkey doen we later
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.pagingindex = 0
      }

      // tel het aantal gefilterde rijen net voor de paging
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.totalrows = Itabledata.length

      // als paging uit staat (0) dan niet filteren op pagina
      if (this.tablesetting.tblPEapiProcTablePagingsize !== 0 && this.paging === true) {
        Itabledata = Itabledata.filter((n, index) => {
          // Als setting table tblPEapiProcTablePaging op true staat dan tblPEapiProcTablePagingsize gebruiken anders alles tonen.
          if (this.tablesetting.tblPEapiProcTablePaging === 1) {
            let rangemin = this.tablesetting.tblPEapiProcTablePagingsize * this.pagingindex
            let rangemax =
              this.tablesetting.tblPEapiProcTablePagingsize * this.pagingindex +
              this.tablesetting.tblPEapiProcTablePagingsize -
              1
            return index >= rangemin && index <= rangemax
          }
          return true
        })
      }

      // format the date in a date column, dit doen we helemaal op het laatst, alleen voor weergave!!
      let returntabledata = Itabledata.map((tablerow) => {
        let newtablerow = {}
        this.tablecolumnsetting.forEach((tablecolumn) => {
          const key = this.firstCharToLowerCase(tablecolumn.tblPEapiProcTableColumnName)
          if (tablecolumn.tblPEapiProcTableColumnType === 'date') {
            if (tablerow[key] === null) {
              newtablerow[key] = ''
            } else {
              if (this.formatDateRelative) {
                newtablerow[key] = util.JSDateToStringDateRelative(new Date(tablerow[key]))
              } else {
                newtablerow[key] = util.jsDateToStringDate(new Date(tablerow[key]))
              }
            }
          } else {
            newtablerow[key] = tablerow[key]
          }
        })
        return newtablerow
      })

      // if (returntabledata.length > this.ThrottleRows){

      //   requestAnimationFrame(() => {
      //     this.ThrottleRows += 5
      //   })
      // } else {
      //   this.$emit('input', returntabledata)

      // }
      this.$emit('input', returntabledata)
      return returntabledata
    },
    tablecolumnsvisible: function () {
      // Als de setting van de tablecolumn op visible = 1 staat, dan word hij getoond.
      let Itablecolumns = this.tablecolumnsetting.filter(function (d) {
        return d.tblPEapiProcTableColumnVisible === 1
      })
      return Itablecolumns
    },
    visiblenext: function () {
      // Als setting table tblPEapiProcTablePaging op true staat dan button tonen anders weglaten
      if (this.tablesetting.tblPEapiProcTablePaging === 1) {
        // Als er nog rijen zijn voor de volgende pagina dan button next tonen.
        let countrows = this.totalrows
        let rangemax =
          this.tablesetting.tblPEapiProcTablePagingsize * this.pagingindex +
          this.tablesetting.tblPEapiProcTablePagingsize
        return countrows >= rangemax
      }
      return false
    },
    visibleprevious: function () {
      // Als setting table tblPEapiProcTablePaging op true staat dan button tonen anders weglaten
      if (this.tablesetting.tblPEapiProcTablePaging === 1) {
        //  Bij de 1e rij, button previous niet tonen.
        return this.pagingindex !== 0
      }
      return false
    },
    toppager: function () {
      //  css searchbox col
      let toppagerclass
      if (this.tableSearchBox === true) {
        if (this.wMD === true || this.wSM === true || this.wXS === true) {
          toppagerclass = 'col-md-offset-4 col-md-4 col-sm-12 col-xs-12 margin20'
        } else {
          toppagerclass = 'col-md-offset-4 col-md-4 col-sm-12 col-xs-12'
        }
      } else {
        toppagerclass = 'col-md-12 col-sm-12 col-xs-12'
      }
      return toppagerclass
    },
  },
  methods: {
    ...mapActions('SPE203Meldingen', ['setMessageId']),
    handleScroll() {
      // vuur event af als de scrollbalk onder op 2/3 van scherm zit
      if ($(window).scrollTop() + $(window).height() >= $(document).height() - $(document).height() / 3) {
        this.$emit('ScrollBottom')
      }

      console.log()
    },

    DefineRowClass: function (tablerow) {
      const rc = {
        XVtableRowSelected: tablerow.tableRowState.rowVisible,
        XVtableRowNotSelected: !tablerow.tableRowState.rowVisible,
      }
      if (tablerow.trclass !== undefined) {
        rc[tablerow.trclass] = tablerow.trclass === null ? '' : tablerow.trclass
      }
      return rc
    },
    iscolumnvisible: function (colVisMd, colVisSm, colVisXs) {
      // responsive classes , geeft aan wanneer een kolom visible moet zijn
      let visclass = ''

      if (colVisXs === 0) {
        visclass = 'hidden-xs '
      }
      if (colVisSm === 0) {
        visclass = 'hidden-xs hidden-sm '
      }
      if (colVisMd === 0) {
        visclass = 'hidden-xs hidden-sm hidden-md hidden-lg '
      }
      return visclass
    },
    iscolumnInVisible: function (colVisMd, colVisSm, colVisXs) {
      // responsive classes , geeft aan wanneer wat er in het detail getoond moet worden
      let visclass = ''
      if (colVisMd === 1) {
        visclass = 'hidden-md hidden-lg '
      }

      if (colVisSm === 1) {
        visclass = 'hidden-sm hidden-md hidden-lg '
      }
      if (colVisXs === 1) {
        visclass = 'hidden-xs hidden-sm hidden-md hidden-lg '
      }

      return visclass
    },
    clicknext: function () {
      //  Paging teller ophogen
      this.pagingindex++
    },
    clickprevious: function () {
      //  Paging teller verlagen
      this.pagingindex--
    },
    sortBy: function (sortKey) {
      // Dit is de onclick event van de header. Op deze column moet er gesorteerd worden.
      // We maken gebruik van de functie sortXVTable die in de state staat van de vue pagina die deze XVtable gebruikt.
      // De sortkey (op welke column gaan we soteren) word meegegeven.
      // Column moet wel sortable zijn en ook op de table moet de setting aan staan.
      this.tablecolumnsetting.forEach((tablecolumn) => {
        if (this.firstCharToLowerCase(tablecolumn.tblPEapiProcTableColumnName) === sortKey) {
          if (tablecolumn.tblPEapiProcTableColumnSortable === 1 && this.tablesetting.tblPEapiProcTableSortable === 1) {
            this.pagingindex = 0
            this.$emit('sortXVTable', {
              sortkey: sortKey,
              tableColumnSettings: this.tablecolumnsetting,
            })
          }
        }
      })
    },
    toggleDetails(tablerow) {
      // hou bij welke detailschermen er geopend zijn
      let visible = !tablerow.tableRowState.rowVisible
      this.XVtableSetRowStateProperty({
        index: tablerow.tableRowState.storeTableindex,
        stateProperty: 'rowVisible',
        statePropertyValue: visible,
      })

      this.chevronUpDown = !this.chevronUpDown
    },
    clearSeachBox: function () {
      this.searchBoxText = ''
    },

    firstCharToLowerCase(string) {
      return util.firstCharToLowerCase(string)
    },
    scrollToRow(id) {
      if (id) {
        setTimeout(() => {
          const msgId = 'msg-' + id
          const rowElement = document.getElementById(CSS.escape(msgId))
          if (rowElement) {
            rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 300)
      }
    },
  },
}
</script>
<style>
.content {
  -webkit-box-flex: 100%;
  -ms-flex: 100% 1 1;
  flex: 100% 1 1;

  position: relative;
}
.dynamic-scroller-demo,
.scroller {
  height: 100%;
}

.XVdatagriditemDiv,
.XVdatagridheaderDiv {
  display: flex;
  flex-direction: row;
  /* min-height: 50px; */
  padding: 5px;
  align-items: center;
  justify-content: center;
}
.XVdatagriditemDiv > div,
.XVdatagridheaderDiv > div {
  flex: 1 1 auto;

  text-align: left;

  margin: 5px;
}

/* 
@media screen and (max-width: 600px) {
  .XVdatagriditemDiv {
    flex-direction: column;
  }
  .XVdatagridheaderDiv {
    display: none;
  }
} */
</style>
